<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDualScreen_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M9.273 5.818C9.273 4.814 10.087 4 11.09 4h9.09C21.187 4 22 4.814 22 5.818v6.364A1.82 1.82 0 0 1 20.182 14H16V8.3a2 2 0 0 0-2-2H9.273zM2 9.455c0-1.005.814-1.819 1.818-1.819h9.091c1.004 0 1.818.814 1.818 1.819v6.363a1.82 1.82 0 0 1-1.818 1.818H3.82A1.82 1.82 0 0 1 2 15.818zm8.108 8.83h-3.36l-.443 1.037c-.082.193.102.392.362.392h3.522c.26 0 .444-.2.362-.392z"
        clip-rule="evenodd"
    />
</svg>
